module.exports = __webpack_public_path__ + "6a7d8cbf5e7ac202ce99528fa5b70f70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr_7.jpg
// module id = 835
// module chunks = 0